import usdtIcon from "../../../media/icons/usdt.png";

export function USDTIcon() {
    return (
        <img src={usdtIcon} width={40} height={40} alt='USDC'/>
    )
}
